// extracted by mini-css-extract-plugin
export default {"popoverWrapper":"JackpotItemInBanner_popoverWrapper--w8S","contentClass":"JackpotItemInBanner_contentClass--w4U","fadeEffect":"JackpotItemInBanner_fadeEffect--ttF"};